/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "search/service/service.proto" (package "rd.search.service", syntax proto3)
// tslint:disable
// @ts-nocheck
import { CxaSearchService } from "./service_pb";
import type { CxaSearchTintColorsRes } from "./service_pb";
import type { CxaSearchTintColorsReq } from "./service_pb";
import type { CxaSearchProductsRes } from "./service_pb";
import type { CxaSearchProductsReq } from "./service_pb";
import type { CxaSearchJobsRes } from "./service_pb";
import type { CxaSearchJobsReq } from "./service_pb";
import type { CxaSearchReturnsRes } from "./service_pb";
import type { CxaSearchReturnsReq } from "./service_pb";
import type { CxaSearchReceivablesAgingRes } from "./service_pb";
import type { CxaSearchReceivablesAgingReq } from "./service_pb";
import type { CxaSearchOutstandingSalesRes } from "./service_pb";
import type { CxaSearchOutstandingSalesReq } from "./service_pb";
import type { CxaSearchSalesRes } from "./service_pb";
import type { CxaSearchSalesReq } from "./service_pb";
import { SearchalyticsService } from "./service_pb";
import type { GetGeneralLedgerCSVRes } from "./service_pb";
import type { GetGeneralLedgerCSVReq } from "./service_pb";
import type { GetGeneralLedgerPDFRes } from "./service_pb";
import type { GetGeneralLedgerPDFReq } from "./service_pb";
import type { GetGeneralLedgerRes } from "./service_pb";
import type { GetGeneralLedgerReq } from "./service_pb";
import type { GetPayoutsByTransactionDateCSVRes } from "./service_pb";
import type { GetPayoutsByTransactionDateCSVReq } from "./service_pb";
import type { GetJournalEntriesIIFRes } from "./service_pb";
import type { GetJournalEntriesIIFReq } from "./service_pb";
import type { GetJournalEntriesPDFRes } from "./service_pb";
import type { GetJournalEntriesPDFReq } from "./service_pb";
import type { GetJournalEntriesRes } from "./service_pb";
import type { GetJournalEntriesReq } from "./service_pb";
import type { GetIncomeStatementRes } from "./service_pb";
import type { GetIncomeStatementReq } from "./service_pb";
import type { GetBalanceSheetRes } from "./service_pb";
import type { GetBalanceSheetReq } from "./service_pb";
import type { GetPayoutsByTransactionDatePDFRes } from "./service_pb";
import type { GetPayoutsByTransactionDatePDFReq } from "./service_pb";
import type { GetPayoutsByTransactionDateRes } from "./service_pb";
import type { GetPayoutsByTransactionDateReq } from "./service_pb";
import type { GetPayoutsByPayoutDateCSVRes } from "./service_pb";
import type { GetPayoutsByPayoutDateCSVReq } from "./service_pb";
import type { GetPayoutsByPayoutDatePDFRes } from "./service_pb";
import type { GetPayoutsByPayoutDatePDFReq } from "./service_pb";
import type { GetPayoutsByPayoutDateRes } from "./service_pb";
import type { GetPayoutsByPayoutDateReq } from "./service_pb";
import type { RefreshSearchalyticsCacheRes } from "./service_pb";
import type { RefreshSearchalyticsCacheReq } from "./service_pb";
import type { GetReportBuilderConfigRes } from "./service_pb";
import type { GetReportBuilderConfigReq } from "./service_pb";
import type { GetReportBuilderEapiRes } from "./service_pb";
import type { GetReportBuilderRes } from "./service_pb";
import type { GetReportBuilderReq } from "./service_pb";
import type { GetPurchaseJournalCSVRes } from "./service_pb";
import type { GetPurchaseJournalCSVReq } from "./service_pb";
import type { GetPurchaseJournalPDFRes } from "./service_pb";
import type { GetPurchaseJournalPDFReq } from "./service_pb";
import type { GetPurchaseJournalRes } from "./service_pb";
import type { GetPurchaseJournalReq } from "./service_pb";
import type { GetProfitAndLossPDFRes } from "./service_pb";
import type { GetProfitAndLossPDFReq } from "./service_pb";
import type { GetProfitAndLossRes } from "./service_pb";
import type { GetProfitAndLossReq } from "./service_pb";
import { BulkService } from "./service_pb";
import type { BulkExportTagsRes } from "./service_pb";
import type { BulkExportTagsReq } from "./service_pb";
import type { BulkExportFinelineRes } from "./service_pb";
import type { BulkExportFinelineReq } from "./service_pb";
import type { BulkExportClassesRes } from "./service_pb";
import type { BulkExportClassesReq } from "./service_pb";
import type { BulkExportDepartmentsRes } from "./service_pb";
import type { BulkExportDepartmentsReq } from "./service_pb";
import type { BulkExportStaffRes } from "./service_pb";
import type { BulkExportStaffReq } from "./service_pb";
import type { BulkExportSpiffsRes } from "./service_pb";
import type { BulkExportSpiffsReq } from "./service_pb";
import type { BulkExportAccountsRes } from "./service_pb";
import type { BulkExportAccountsReq } from "./service_pb";
import type { BulkExportMappingsRes } from "./service_pb";
import type { BulkExportMappingsReq } from "./service_pb";
import type { BulkExportCustomPriceRulesRes } from "./service_pb";
import type { BulkExportCustomPriceRulesReq } from "./service_pb";
import type { BulkExportInventoryCountProductsRes } from "./service_pb";
import type { BulkExportInventoryCountProductsReq } from "./service_pb";
import type { BulkExportUnitsOfMeasureRes } from "./service_pb";
import type { BulkExportUnitsOfMeasureReq } from "./service_pb";
import type { BulkExportVendorsRes } from "./service_pb";
import type { BulkExportVendorsReq } from "./service_pb";
import type { BulkExportProductLabelsRes } from "./service_pb";
import type { BulkExportProductLabelsReq } from "./service_pb";
import type { BulkExportProductsRes } from "./service_pb";
import type { BulkExportProductsReq } from "./service_pb";
import type { BulkExportCustomerContactsRes } from "./service_pb";
import type { BulkExportCustomerContactsReq } from "./service_pb";
import type { BulkExportJobsRes } from "./service_pb";
import type { BulkExportJobsReq } from "./service_pb";
import type { BulkExportCustomersRes } from "./service_pb";
import type { BulkExportCustomersReq } from "./service_pb";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { SearchService } from "./service_pb";
import type { SearchListPromotionalSaleCodesRes } from "./service_pb";
import type { SearchListPromotionalSaleCodesReq } from "./service_pb";
import type { SearchConversationsRes } from "./service_pb";
import type { SearchConversationsReq } from "./service_pb";
import type { SearchRoutinesRes } from "./service_pb";
import type { SearchRoutinesReq } from "./service_pb";
import type { SearchSpiffsRes } from "./service_pb";
import type { SearchSpiffsReq } from "./service_pb";
import type { SearchGiftCardsRes } from "./service_pb";
import type { SearchGiftCardsReq } from "./service_pb";
import type { SearchCatalogProductsRes } from "./service_pb";
import type { SearchCatalogProductsReq } from "./service_pb";
import type { ListIntegrationVendorsWithCatalogsRes } from "./service_pb";
import type { ListIntegrationVendorsWithCatalogsReq } from "./service_pb";
import type { SearchCatalogSKUsRes } from "./service_pb";
import type { SearchCatalogSKUsReq } from "./service_pb";
import type { PollForUnreadChatThreadsRes } from "./service_pb";
import type { PollForUnreadChatThreadsReq } from "./service_pb";
import type { PollForNewChatMessagesRes } from "./service_pb";
import type { PollForNewChatMessagesReq } from "./service_pb";
import type { SearchChatMessagesRes } from "./service_pb";
import type { SearchChatMessagesReq } from "./service_pb";
import type { SearchChatThreadsRes } from "./service_pb";
import type { SearchChatThreadsReq } from "./service_pb";
import type { OmniSearchRes } from "./service_pb";
import type { OmniSearchReq } from "./service_pb";
import type { SearchReallocationReceivablesRes } from "./service_pb";
import type { SearchReallocationReceivablesReq } from "./service_pb";
import type { PrintReceivablesAgingRes } from "./service_pb";
import type { PrintReceivablesAgingReq } from "./service_pb";
import type { SearchReceivablesAgingRes } from "./service_pb";
import type { SearchReceivablesAgingReq } from "./service_pb";
import type { PrintReceivablesHistoryRes } from "./service_pb";
import type { PrintReceivablesHistoryReq } from "./service_pb";
import type { SearchPriceChangesRes } from "./service_pb";
import type { SearchPriceChangesReq } from "./service_pb";
import type { SearchReceivablesHistoryRes } from "./service_pb";
import type { SearchReceivablesHistoryReq } from "./service_pb";
import type { SearchTenderMethodsRes } from "./service_pb";
import type { SearchTenderMethodsReq } from "./service_pb";
import type { SearchSavedReportsRes } from "./service_pb";
import type { SearchSavedReportsReq } from "./service_pb";
import type { SearchManualJournalEntriesRes } from "./service_pb";
import type { SearchManualJournalEntriesReq } from "./service_pb";
import type { SearchJournalEntriesRes } from "./service_pb";
import type { SearchJournalEntriesReq } from "./service_pb";
import type { SearchMappingsRes } from "./service_pb";
import type { SearchMappingsReq } from "./service_pb";
import type { SearchAccountsRes } from "./service_pb";
import type { SearchAccountsReq } from "./service_pb";
import type { SearchCreditsRes } from "./service_pb";
import type { SearchCreditsReq } from "./service_pb";
import type { SearchReturnableSaleProductsRes } from "./service_pb";
import type { SearchReturnableSaleProductsReq } from "./service_pb";
import type { SearchCustomerStatementsRes } from "./service_pb";
import type { SearchCustomerStatementsReq } from "./service_pb";
import type { SearchStatementRunsRes } from "./service_pb";
import type { SearchStatementRunsReq } from "./service_pb";
import type { SearchStatementsRes } from "./service_pb";
import type { SearchStatementsReq } from "./service_pb";
import type { SearchFinanceChargesRes } from "./service_pb";
import type { SearchFinanceChargesReq } from "./service_pb";
import type { PreviewGeneratedOrderProductsRes } from "./service_pb";
import type { PreviewGeneratedOrderProductsReq } from "./service_pb";
import type { SearchStagedProductsToOrderRes } from "./service_pb";
import type { SearchStagedProductsToOrderReq } from "./service_pb";
import type { SearchTagsRes } from "./service_pb";
import type { SearchTagsReq } from "./service_pb";
import type { SearchJobsRes } from "./service_pb";
import type { SearchJobsReq } from "./service_pb";
import type { SearchPriceTierRulesRes } from "./service_pb";
import type { SearchPriceTierRulesReq } from "./service_pb";
import type { SearchCustomPriceRulesRes } from "./service_pb";
import type { SearchCustomPriceRulesReq } from "./service_pb";
import type { SearchInventoryChangesRes } from "./service_pb";
import type { SearchInventoryChangesReq } from "./service_pb";
import type { SearchOrderShipmentsForReconciliationRes } from "./service_pb";
import type { SearchOrderShipmentsForReconciliationReq } from "./service_pb";
import type { ReloadRes } from "./service_pb";
import type { ReloadReq } from "./service_pb";
import type { UpdateRecordRes } from "./service_pb";
import type { UpdateRecordReq } from "./service_pb";
import type { SearchFinancialTransactionsRes } from "./service_pb";
import type { SearchFinancialTransactionsReq } from "./service_pb";
import type { SearchNotifDeliveriesRes } from "./service_pb";
import type { SearchNotifDeliveriesReq } from "./service_pb";
import type { SearchCashTransactionsRes } from "./service_pb";
import type { SearchCashTransactionsReq } from "./service_pb";
import type { SearchVendorsRes } from "./service_pb";
import type { SearchVendorsReq } from "./service_pb";
import type { SearchTransfersRes } from "./service_pb";
import type { SearchTransfersReq } from "./service_pb";
import type { SearchTintColorsRes } from "./service_pb";
import type { SearchTintColorsReq } from "./service_pb";
import type { SearchOutstandingSalesRes } from "./service_pb";
import type { SearchOutstandingSalesReq } from "./service_pb";
import type { SearchReturnsRes } from "./service_pb";
import type { SearchReturnsReq } from "./service_pb";
import type { SearchStaffsRes } from "./service_pb";
import type { SearchStaffsReq } from "./service_pb";
import type { SearchSalesV2Res } from "./service_pb";
import type { SearchSalesV2Req } from "./service_pb";
import type { SearchProductCategoriesRes } from "./service_pb";
import type { SearchProductCategoriesReq } from "./service_pb";
import type { SearchProductsV2Res } from "./service_pb";
import type { SearchProductsV2Req } from "./service_pb";
import type { SearchOrderShipmentsRes } from "./service_pb";
import type { SearchOrderShipmentsReq } from "./service_pb";
import type { SearchOrdersRes } from "./service_pb";
import type { SearchOrdersReq } from "./service_pb";
import type { SearchLocationsRes } from "./service_pb";
import type { SearchLocationsReq } from "./service_pb";
import type { SearchDeliveryStopsRes } from "./service_pb";
import type { SearchDeliveryStopsReq } from "./service_pb";
import type { SearchDeliveriesRes } from "./service_pb";
import type { SearchDeliveriesReq } from "./service_pb";
import type { SearchExcludedInventoryCountProductsRes } from "./service_pb";
import type { SearchExcludedInventoryCountProductsReq } from "./service_pb";
import type { SearchInventoryCountProductsRes } from "./service_pb";
import type { SearchInventoryCountProductsReq } from "./service_pb";
import type { SearchExternalTransactionsRes } from "./service_pb";
import type { SearchExternalTransactionsReq } from "./service_pb";
import type { SearchCustomerContactsRes } from "./service_pb";
import type { SearchCustomerContactsReq } from "./service_pb";
import type { SearchCustomersV2Res } from "./service_pb";
import type { SearchCustomersV2Req } from "./service_pb";
import type { SearchRefundedBillPaymentsRes } from "./service_pb";
import type { SearchRefundedBillPaymentsReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { SearchBillPaymentsRes } from "./service_pb";
import type { SearchBillPaymentsReq } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.search.service.SearchService
 */
export interface ISearchServiceClient {
    /**
     * @generated from protobuf rpc: SearchBillPayments
     */
    searchBillPayments(input: SearchBillPaymentsReq, options?: RpcOptions): UnaryCall<SearchBillPaymentsReq, SearchBillPaymentsRes>;
    /**
     * @generated from protobuf rpc: SearchRefundedBillPayments
     */
    searchRefundedBillPayments(input: SearchRefundedBillPaymentsReq, options?: RpcOptions): UnaryCall<SearchRefundedBillPaymentsReq, SearchRefundedBillPaymentsRes>;
    /**
     * @generated from protobuf rpc: SearchCustomersV2
     */
    searchCustomersV2(input: SearchCustomersV2Req, options?: RpcOptions): UnaryCall<SearchCustomersV2Req, SearchCustomersV2Res>;
    /**
     * @generated from protobuf rpc: SearchCustomerContacts
     */
    searchCustomerContacts(input: SearchCustomerContactsReq, options?: RpcOptions): UnaryCall<SearchCustomerContactsReq, SearchCustomerContactsRes>;
    /**
     * @generated from protobuf rpc: SearchExternalTransactions
     */
    searchExternalTransactions(input: SearchExternalTransactionsReq, options?: RpcOptions): UnaryCall<SearchExternalTransactionsReq, SearchExternalTransactionsRes>;
    /**
     * @generated from protobuf rpc: SearchInventoryCountProducts
     */
    searchInventoryCountProducts(input: SearchInventoryCountProductsReq, options?: RpcOptions): UnaryCall<SearchInventoryCountProductsReq, SearchInventoryCountProductsRes>;
    /**
     * @generated from protobuf rpc: SearchExcludedInventoryCountProducts
     */
    searchExcludedInventoryCountProducts(input: SearchExcludedInventoryCountProductsReq, options?: RpcOptions): UnaryCall<SearchExcludedInventoryCountProductsReq, SearchExcludedInventoryCountProductsRes>;
    /**
     * @generated from protobuf rpc: SearchDeliveries
     */
    searchDeliveries(input: SearchDeliveriesReq, options?: RpcOptions): UnaryCall<SearchDeliveriesReq, SearchDeliveriesRes>;
    /**
     * @generated from protobuf rpc: SearchDeliveryStops
     */
    searchDeliveryStops(input: SearchDeliveryStopsReq, options?: RpcOptions): UnaryCall<SearchDeliveryStopsReq, SearchDeliveryStopsRes>;
    /**
     * @generated from protobuf rpc: SearchLocations
     */
    searchLocations(input: SearchLocationsReq, options?: RpcOptions): UnaryCall<SearchLocationsReq, SearchLocationsRes>;
    /**
     * @generated from protobuf rpc: SearchOrders
     */
    searchOrders(input: SearchOrdersReq, options?: RpcOptions): UnaryCall<SearchOrdersReq, SearchOrdersRes>;
    /**
     * @generated from protobuf rpc: SearchOrderShipments
     */
    searchOrderShipments(input: SearchOrderShipmentsReq, options?: RpcOptions): UnaryCall<SearchOrderShipmentsReq, SearchOrderShipmentsRes>;
    /**
     * @generated from protobuf rpc: SearchProductsV2
     */
    searchProductsV2(input: SearchProductsV2Req, options?: RpcOptions): UnaryCall<SearchProductsV2Req, SearchProductsV2Res>;
    /**
     * @generated from protobuf rpc: SearchProductCategories
     */
    searchProductCategories(input: SearchProductCategoriesReq, options?: RpcOptions): UnaryCall<SearchProductCategoriesReq, SearchProductCategoriesRes>;
    /**
     * @generated from protobuf rpc: SearchSalesV2
     */
    searchSalesV2(input: SearchSalesV2Req, options?: RpcOptions): UnaryCall<SearchSalesV2Req, SearchSalesV2Res>;
    /**
     * @generated from protobuf rpc: SearchStaffs
     */
    searchStaffs(input: SearchStaffsReq, options?: RpcOptions): UnaryCall<SearchStaffsReq, SearchStaffsRes>;
    /**
     * @generated from protobuf rpc: SearchReturns
     */
    searchReturns(input: SearchReturnsReq, options?: RpcOptions): UnaryCall<SearchReturnsReq, SearchReturnsRes>;
    /**
     * @generated from protobuf rpc: SearchOutstandingSales
     */
    searchOutstandingSales(input: SearchOutstandingSalesReq, options?: RpcOptions): UnaryCall<SearchOutstandingSalesReq, SearchOutstandingSalesRes>;
    /**
     * @generated from protobuf rpc: SearchTintColors
     */
    searchTintColors(input: SearchTintColorsReq, options?: RpcOptions): UnaryCall<SearchTintColorsReq, SearchTintColorsRes>;
    /**
     * @generated from protobuf rpc: SearchTransfers
     */
    searchTransfers(input: SearchTransfersReq, options?: RpcOptions): UnaryCall<SearchTransfersReq, SearchTransfersRes>;
    /**
     * @generated from protobuf rpc: SearchVendors
     */
    searchVendors(input: SearchVendorsReq, options?: RpcOptions): UnaryCall<SearchVendorsReq, SearchVendorsRes>;
    /**
     * @generated from protobuf rpc: SearchCashTransactions
     */
    searchCashTransactions(input: SearchCashTransactionsReq, options?: RpcOptions): UnaryCall<SearchCashTransactionsReq, SearchCashTransactionsRes>;
    /**
     * @generated from protobuf rpc: SearchNotifDeliveries
     */
    searchNotifDeliveries(input: SearchNotifDeliveriesReq, options?: RpcOptions): UnaryCall<SearchNotifDeliveriesReq, SearchNotifDeliveriesRes>;
    /**
     * @generated from protobuf rpc: SearchFinancialTransactions
     */
    searchFinancialTransactions(input: SearchFinancialTransactionsReq, options?: RpcOptions): UnaryCall<SearchFinancialTransactionsReq, SearchFinancialTransactionsRes>;
    /**
     * @generated from protobuf rpc: UpdateRecord
     */
    updateRecord(input: UpdateRecordReq, options?: RpcOptions): UnaryCall<UpdateRecordReq, UpdateRecordRes>;
    /**
     * @generated from protobuf rpc: Reload
     */
    reload(input: ReloadReq, options?: RpcOptions): UnaryCall<ReloadReq, ReloadRes>;
    /**
     * @generated from protobuf rpc: SearchOrderShipmentsForReconciliation
     */
    searchOrderShipmentsForReconciliation(input: SearchOrderShipmentsForReconciliationReq, options?: RpcOptions): UnaryCall<SearchOrderShipmentsForReconciliationReq, SearchOrderShipmentsForReconciliationRes>;
    /**
     * @generated from protobuf rpc: SearchInventoryChanges
     */
    searchInventoryChanges(input: SearchInventoryChangesReq, options?: RpcOptions): UnaryCall<SearchInventoryChangesReq, SearchInventoryChangesRes>;
    /**
     * @generated from protobuf rpc: SearchCustomPriceRules
     */
    searchCustomPriceRules(input: SearchCustomPriceRulesReq, options?: RpcOptions): UnaryCall<SearchCustomPriceRulesReq, SearchCustomPriceRulesRes>;
    /**
     * @generated from protobuf rpc: SearchPriceTierRules
     */
    searchPriceTierRules(input: SearchPriceTierRulesReq, options?: RpcOptions): UnaryCall<SearchPriceTierRulesReq, SearchPriceTierRulesRes>;
    /**
     * @generated from protobuf rpc: SearchJobs
     */
    searchJobs(input: SearchJobsReq, options?: RpcOptions): UnaryCall<SearchJobsReq, SearchJobsRes>;
    /**
     * @generated from protobuf rpc: SearchTags
     */
    searchTags(input: SearchTagsReq, options?: RpcOptions): UnaryCall<SearchTagsReq, SearchTagsRes>;
    /**
     * @generated from protobuf rpc: SearchStagedProductsToOrder
     */
    searchStagedProductsToOrder(input: SearchStagedProductsToOrderReq, options?: RpcOptions): UnaryCall<SearchStagedProductsToOrderReq, SearchStagedProductsToOrderRes>;
    /**
     * @generated from protobuf rpc: PreviewGeneratedOrderProducts
     */
    previewGeneratedOrderProducts(input: PreviewGeneratedOrderProductsReq, options?: RpcOptions): UnaryCall<PreviewGeneratedOrderProductsReq, PreviewGeneratedOrderProductsRes>;
    /**
     * @generated from protobuf rpc: SearchFinanceCharges
     */
    searchFinanceCharges(input: SearchFinanceChargesReq, options?: RpcOptions): UnaryCall<SearchFinanceChargesReq, SearchFinanceChargesRes>;
    /**
     * @generated from protobuf rpc: SearchStatements
     */
    searchStatements(input: SearchStatementsReq, options?: RpcOptions): UnaryCall<SearchStatementsReq, SearchStatementsRes>;
    /**
     * @generated from protobuf rpc: SearchStatementRuns
     */
    searchStatementRuns(input: SearchStatementRunsReq, options?: RpcOptions): UnaryCall<SearchStatementRunsReq, SearchStatementRunsRes>;
    /**
     * @generated from protobuf rpc: SearchCustomerStatements
     */
    searchCustomerStatements(input: SearchCustomerStatementsReq, options?: RpcOptions): UnaryCall<SearchCustomerStatementsReq, SearchCustomerStatementsRes>;
    /**
     * @generated from protobuf rpc: SearchReturnableSaleProducts
     */
    searchReturnableSaleProducts(input: SearchReturnableSaleProductsReq, options?: RpcOptions): UnaryCall<SearchReturnableSaleProductsReq, SearchReturnableSaleProductsRes>;
    /**
     * @generated from protobuf rpc: SearchCredits
     */
    searchCredits(input: SearchCreditsReq, options?: RpcOptions): UnaryCall<SearchCreditsReq, SearchCreditsRes>;
    /**
     * @generated from protobuf rpc: SearchAccounts
     */
    searchAccounts(input: SearchAccountsReq, options?: RpcOptions): UnaryCall<SearchAccountsReq, SearchAccountsRes>;
    /**
     * @generated from protobuf rpc: SearchMappings
     */
    searchMappings(input: SearchMappingsReq, options?: RpcOptions): UnaryCall<SearchMappingsReq, SearchMappingsRes>;
    /**
     * @generated from protobuf rpc: SearchJournalEntries
     */
    searchJournalEntries(input: SearchJournalEntriesReq, options?: RpcOptions): UnaryCall<SearchJournalEntriesReq, SearchJournalEntriesRes>;
    /**
     * @generated from protobuf rpc: SearchManualJournalEntries
     */
    searchManualJournalEntries(input: SearchManualJournalEntriesReq, options?: RpcOptions): UnaryCall<SearchManualJournalEntriesReq, SearchManualJournalEntriesRes>;
    /**
     * @generated from protobuf rpc: SearchSavedReports
     */
    searchSavedReports(input: SearchSavedReportsReq, options?: RpcOptions): UnaryCall<SearchSavedReportsReq, SearchSavedReportsRes>;
    /**
     * @generated from protobuf rpc: SearchTenderMethods
     */
    searchTenderMethods(input: SearchTenderMethodsReq, options?: RpcOptions): UnaryCall<SearchTenderMethodsReq, SearchTenderMethodsRes>;
    /**
     * @generated from protobuf rpc: SearchReceivablesHistory
     */
    searchReceivablesHistory(input: SearchReceivablesHistoryReq, options?: RpcOptions): UnaryCall<SearchReceivablesHistoryReq, SearchReceivablesHistoryRes>;
    /**
     * @generated from protobuf rpc: SearchPriceChanges
     */
    searchPriceChanges(input: SearchPriceChangesReq, options?: RpcOptions): UnaryCall<SearchPriceChangesReq, SearchPriceChangesRes>;
    /**
     * @generated from protobuf rpc: PrintReceivablesHistory
     */
    printReceivablesHistory(input: PrintReceivablesHistoryReq, options?: RpcOptions): UnaryCall<PrintReceivablesHistoryReq, PrintReceivablesHistoryRes>;
    /**
     * @generated from protobuf rpc: SearchReceivablesAging
     */
    searchReceivablesAging(input: SearchReceivablesAgingReq, options?: RpcOptions): UnaryCall<SearchReceivablesAgingReq, SearchReceivablesAgingRes>;
    /**
     * @generated from protobuf rpc: PrintReceivablesAging
     */
    printReceivablesAging(input: PrintReceivablesAgingReq, options?: RpcOptions): UnaryCall<PrintReceivablesAgingReq, PrintReceivablesAgingRes>;
    /**
     * @generated from protobuf rpc: SearchReallocationReceivables
     */
    searchReallocationReceivables(input: SearchReallocationReceivablesReq, options?: RpcOptions): UnaryCall<SearchReallocationReceivablesReq, SearchReallocationReceivablesRes>;
    /**
     * @generated from protobuf rpc: OmniSearch
     */
    omniSearch(input: OmniSearchReq, options?: RpcOptions): UnaryCall<OmniSearchReq, OmniSearchRes>;
    /**
     * @generated from protobuf rpc: SearchChatThreads
     */
    searchChatThreads(input: SearchChatThreadsReq, options?: RpcOptions): UnaryCall<SearchChatThreadsReq, SearchChatThreadsRes>;
    /**
     * @generated from protobuf rpc: SearchChatMessages
     */
    searchChatMessages(input: SearchChatMessagesReq, options?: RpcOptions): UnaryCall<SearchChatMessagesReq, SearchChatMessagesRes>;
    /**
     * @generated from protobuf rpc: PollForNewChatMessages
     */
    pollForNewChatMessages(input: PollForNewChatMessagesReq, options?: RpcOptions): UnaryCall<PollForNewChatMessagesReq, PollForNewChatMessagesRes>;
    /**
     * @generated from protobuf rpc: PollForUnreadChatThreads
     */
    pollForUnreadChatThreads(input: PollForUnreadChatThreadsReq, options?: RpcOptions): UnaryCall<PollForUnreadChatThreadsReq, PollForUnreadChatThreadsRes>;
    /**
     * @generated from protobuf rpc: SearchCatalogSKUs
     */
    searchCatalogSKUs(input: SearchCatalogSKUsReq, options?: RpcOptions): UnaryCall<SearchCatalogSKUsReq, SearchCatalogSKUsRes>;
    /**
     * @generated from protobuf rpc: ListIntegrationVendorsWithCatalogs
     */
    listIntegrationVendorsWithCatalogs(input: ListIntegrationVendorsWithCatalogsReq, options?: RpcOptions): UnaryCall<ListIntegrationVendorsWithCatalogsReq, ListIntegrationVendorsWithCatalogsRes>;
    /**
     * @generated from protobuf rpc: SearchCatalogProducts
     */
    searchCatalogProducts(input: SearchCatalogProductsReq, options?: RpcOptions): UnaryCall<SearchCatalogProductsReq, SearchCatalogProductsRes>;
    /**
     * @generated from protobuf rpc: SearchGiftCards
     */
    searchGiftCards(input: SearchGiftCardsReq, options?: RpcOptions): UnaryCall<SearchGiftCardsReq, SearchGiftCardsRes>;
    /**
     * @generated from protobuf rpc: SearchSpiffs
     */
    searchSpiffs(input: SearchSpiffsReq, options?: RpcOptions): UnaryCall<SearchSpiffsReq, SearchSpiffsRes>;
    /**
     * @generated from protobuf rpc: SearchRoutines
     */
    searchRoutines(input: SearchRoutinesReq, options?: RpcOptions): UnaryCall<SearchRoutinesReq, SearchRoutinesRes>;
    /**
     * @generated from protobuf rpc: SearchConversations
     */
    searchConversations(input: SearchConversationsReq, options?: RpcOptions): UnaryCall<SearchConversationsReq, SearchConversationsRes>;
    /**
     * @generated from protobuf rpc: SearchListPromotionalSaleCodes
     */
    searchListPromotionalSaleCodes(input: SearchListPromotionalSaleCodesReq, options?: RpcOptions): UnaryCall<SearchListPromotionalSaleCodesReq, SearchListPromotionalSaleCodesRes>;
}
/**
 * @generated from protobuf service rd.search.service.SearchService
 */
export class SearchServiceClient implements ISearchServiceClient, ServiceInfo {
    typeName = SearchService.typeName;
    methods = SearchService.methods;
    options = SearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: SearchBillPayments
     */
    searchBillPayments(input: SearchBillPaymentsReq, options?: RpcOptions): UnaryCall<SearchBillPaymentsReq, SearchBillPaymentsRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchBillPaymentsReq, SearchBillPaymentsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchRefundedBillPayments
     */
    searchRefundedBillPayments(input: SearchRefundedBillPaymentsReq, options?: RpcOptions): UnaryCall<SearchRefundedBillPaymentsReq, SearchRefundedBillPaymentsRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchRefundedBillPaymentsReq, SearchRefundedBillPaymentsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCustomersV2
     */
    searchCustomersV2(input: SearchCustomersV2Req, options?: RpcOptions): UnaryCall<SearchCustomersV2Req, SearchCustomersV2Res> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCustomersV2Req, SearchCustomersV2Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCustomerContacts
     */
    searchCustomerContacts(input: SearchCustomerContactsReq, options?: RpcOptions): UnaryCall<SearchCustomerContactsReq, SearchCustomerContactsRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCustomerContactsReq, SearchCustomerContactsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchExternalTransactions
     */
    searchExternalTransactions(input: SearchExternalTransactionsReq, options?: RpcOptions): UnaryCall<SearchExternalTransactionsReq, SearchExternalTransactionsRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchExternalTransactionsReq, SearchExternalTransactionsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchInventoryCountProducts
     */
    searchInventoryCountProducts(input: SearchInventoryCountProductsReq, options?: RpcOptions): UnaryCall<SearchInventoryCountProductsReq, SearchInventoryCountProductsRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchInventoryCountProductsReq, SearchInventoryCountProductsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchExcludedInventoryCountProducts
     */
    searchExcludedInventoryCountProducts(input: SearchExcludedInventoryCountProductsReq, options?: RpcOptions): UnaryCall<SearchExcludedInventoryCountProductsReq, SearchExcludedInventoryCountProductsRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchExcludedInventoryCountProductsReq, SearchExcludedInventoryCountProductsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchDeliveries
     */
    searchDeliveries(input: SearchDeliveriesReq, options?: RpcOptions): UnaryCall<SearchDeliveriesReq, SearchDeliveriesRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchDeliveriesReq, SearchDeliveriesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchDeliveryStops
     */
    searchDeliveryStops(input: SearchDeliveryStopsReq, options?: RpcOptions): UnaryCall<SearchDeliveryStopsReq, SearchDeliveryStopsRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchDeliveryStopsReq, SearchDeliveryStopsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchLocations
     */
    searchLocations(input: SearchLocationsReq, options?: RpcOptions): UnaryCall<SearchLocationsReq, SearchLocationsRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchLocationsReq, SearchLocationsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchOrders
     */
    searchOrders(input: SearchOrdersReq, options?: RpcOptions): UnaryCall<SearchOrdersReq, SearchOrdersRes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchOrdersReq, SearchOrdersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchOrderShipments
     */
    searchOrderShipments(input: SearchOrderShipmentsReq, options?: RpcOptions): UnaryCall<SearchOrderShipmentsReq, SearchOrderShipmentsRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchOrderShipmentsReq, SearchOrderShipmentsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchProductsV2
     */
    searchProductsV2(input: SearchProductsV2Req, options?: RpcOptions): UnaryCall<SearchProductsV2Req, SearchProductsV2Res> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchProductsV2Req, SearchProductsV2Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchProductCategories
     */
    searchProductCategories(input: SearchProductCategoriesReq, options?: RpcOptions): UnaryCall<SearchProductCategoriesReq, SearchProductCategoriesRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchProductCategoriesReq, SearchProductCategoriesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchSalesV2
     */
    searchSalesV2(input: SearchSalesV2Req, options?: RpcOptions): UnaryCall<SearchSalesV2Req, SearchSalesV2Res> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchSalesV2Req, SearchSalesV2Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchStaffs
     */
    searchStaffs(input: SearchStaffsReq, options?: RpcOptions): UnaryCall<SearchStaffsReq, SearchStaffsRes> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchStaffsReq, SearchStaffsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchReturns
     */
    searchReturns(input: SearchReturnsReq, options?: RpcOptions): UnaryCall<SearchReturnsReq, SearchReturnsRes> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchReturnsReq, SearchReturnsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchOutstandingSales
     */
    searchOutstandingSales(input: SearchOutstandingSalesReq, options?: RpcOptions): UnaryCall<SearchOutstandingSalesReq, SearchOutstandingSalesRes> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchOutstandingSalesReq, SearchOutstandingSalesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchTintColors
     */
    searchTintColors(input: SearchTintColorsReq, options?: RpcOptions): UnaryCall<SearchTintColorsReq, SearchTintColorsRes> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchTintColorsReq, SearchTintColorsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchTransfers
     */
    searchTransfers(input: SearchTransfersReq, options?: RpcOptions): UnaryCall<SearchTransfersReq, SearchTransfersRes> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchTransfersReq, SearchTransfersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchVendors
     */
    searchVendors(input: SearchVendorsReq, options?: RpcOptions): UnaryCall<SearchVendorsReq, SearchVendorsRes> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchVendorsReq, SearchVendorsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCashTransactions
     */
    searchCashTransactions(input: SearchCashTransactionsReq, options?: RpcOptions): UnaryCall<SearchCashTransactionsReq, SearchCashTransactionsRes> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCashTransactionsReq, SearchCashTransactionsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchNotifDeliveries
     */
    searchNotifDeliveries(input: SearchNotifDeliveriesReq, options?: RpcOptions): UnaryCall<SearchNotifDeliveriesReq, SearchNotifDeliveriesRes> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchNotifDeliveriesReq, SearchNotifDeliveriesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchFinancialTransactions
     */
    searchFinancialTransactions(input: SearchFinancialTransactionsReq, options?: RpcOptions): UnaryCall<SearchFinancialTransactionsReq, SearchFinancialTransactionsRes> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchFinancialTransactionsReq, SearchFinancialTransactionsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateRecord
     */
    updateRecord(input: UpdateRecordReq, options?: RpcOptions): UnaryCall<UpdateRecordReq, UpdateRecordRes> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateRecordReq, UpdateRecordRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Reload
     */
    reload(input: ReloadReq, options?: RpcOptions): UnaryCall<ReloadReq, ReloadRes> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReloadReq, ReloadRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchOrderShipmentsForReconciliation
     */
    searchOrderShipmentsForReconciliation(input: SearchOrderShipmentsForReconciliationReq, options?: RpcOptions): UnaryCall<SearchOrderShipmentsForReconciliationReq, SearchOrderShipmentsForReconciliationRes> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchOrderShipmentsForReconciliationReq, SearchOrderShipmentsForReconciliationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchInventoryChanges
     */
    searchInventoryChanges(input: SearchInventoryChangesReq, options?: RpcOptions): UnaryCall<SearchInventoryChangesReq, SearchInventoryChangesRes> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchInventoryChangesReq, SearchInventoryChangesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCustomPriceRules
     */
    searchCustomPriceRules(input: SearchCustomPriceRulesReq, options?: RpcOptions): UnaryCall<SearchCustomPriceRulesReq, SearchCustomPriceRulesRes> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCustomPriceRulesReq, SearchCustomPriceRulesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchPriceTierRules
     */
    searchPriceTierRules(input: SearchPriceTierRulesReq, options?: RpcOptions): UnaryCall<SearchPriceTierRulesReq, SearchPriceTierRulesRes> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchPriceTierRulesReq, SearchPriceTierRulesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchJobs
     */
    searchJobs(input: SearchJobsReq, options?: RpcOptions): UnaryCall<SearchJobsReq, SearchJobsRes> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchJobsReq, SearchJobsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchTags
     */
    searchTags(input: SearchTagsReq, options?: RpcOptions): UnaryCall<SearchTagsReq, SearchTagsRes> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchTagsReq, SearchTagsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchStagedProductsToOrder
     */
    searchStagedProductsToOrder(input: SearchStagedProductsToOrderReq, options?: RpcOptions): UnaryCall<SearchStagedProductsToOrderReq, SearchStagedProductsToOrderRes> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchStagedProductsToOrderReq, SearchStagedProductsToOrderRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PreviewGeneratedOrderProducts
     */
    previewGeneratedOrderProducts(input: PreviewGeneratedOrderProductsReq, options?: RpcOptions): UnaryCall<PreviewGeneratedOrderProductsReq, PreviewGeneratedOrderProductsRes> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<PreviewGeneratedOrderProductsReq, PreviewGeneratedOrderProductsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchFinanceCharges
     */
    searchFinanceCharges(input: SearchFinanceChargesReq, options?: RpcOptions): UnaryCall<SearchFinanceChargesReq, SearchFinanceChargesRes> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchFinanceChargesReq, SearchFinanceChargesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchStatements
     */
    searchStatements(input: SearchStatementsReq, options?: RpcOptions): UnaryCall<SearchStatementsReq, SearchStatementsRes> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchStatementsReq, SearchStatementsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchStatementRuns
     */
    searchStatementRuns(input: SearchStatementRunsReq, options?: RpcOptions): UnaryCall<SearchStatementRunsReq, SearchStatementRunsRes> {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchStatementRunsReq, SearchStatementRunsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCustomerStatements
     */
    searchCustomerStatements(input: SearchCustomerStatementsReq, options?: RpcOptions): UnaryCall<SearchCustomerStatementsReq, SearchCustomerStatementsRes> {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCustomerStatementsReq, SearchCustomerStatementsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchReturnableSaleProducts
     */
    searchReturnableSaleProducts(input: SearchReturnableSaleProductsReq, options?: RpcOptions): UnaryCall<SearchReturnableSaleProductsReq, SearchReturnableSaleProductsRes> {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchReturnableSaleProductsReq, SearchReturnableSaleProductsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCredits
     */
    searchCredits(input: SearchCreditsReq, options?: RpcOptions): UnaryCall<SearchCreditsReq, SearchCreditsRes> {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCreditsReq, SearchCreditsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAccounts
     */
    searchAccounts(input: SearchAccountsReq, options?: RpcOptions): UnaryCall<SearchAccountsReq, SearchAccountsRes> {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAccountsReq, SearchAccountsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchMappings
     */
    searchMappings(input: SearchMappingsReq, options?: RpcOptions): UnaryCall<SearchMappingsReq, SearchMappingsRes> {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchMappingsReq, SearchMappingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchJournalEntries
     */
    searchJournalEntries(input: SearchJournalEntriesReq, options?: RpcOptions): UnaryCall<SearchJournalEntriesReq, SearchJournalEntriesRes> {
        const method = this.methods[42], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchJournalEntriesReq, SearchJournalEntriesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchManualJournalEntries
     */
    searchManualJournalEntries(input: SearchManualJournalEntriesReq, options?: RpcOptions): UnaryCall<SearchManualJournalEntriesReq, SearchManualJournalEntriesRes> {
        const method = this.methods[43], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchManualJournalEntriesReq, SearchManualJournalEntriesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchSavedReports
     */
    searchSavedReports(input: SearchSavedReportsReq, options?: RpcOptions): UnaryCall<SearchSavedReportsReq, SearchSavedReportsRes> {
        const method = this.methods[44], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchSavedReportsReq, SearchSavedReportsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchTenderMethods
     */
    searchTenderMethods(input: SearchTenderMethodsReq, options?: RpcOptions): UnaryCall<SearchTenderMethodsReq, SearchTenderMethodsRes> {
        const method = this.methods[45], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchTenderMethodsReq, SearchTenderMethodsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchReceivablesHistory
     */
    searchReceivablesHistory(input: SearchReceivablesHistoryReq, options?: RpcOptions): UnaryCall<SearchReceivablesHistoryReq, SearchReceivablesHistoryRes> {
        const method = this.methods[46], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchReceivablesHistoryReq, SearchReceivablesHistoryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchPriceChanges
     */
    searchPriceChanges(input: SearchPriceChangesReq, options?: RpcOptions): UnaryCall<SearchPriceChangesReq, SearchPriceChangesRes> {
        const method = this.methods[47], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchPriceChangesReq, SearchPriceChangesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PrintReceivablesHistory
     */
    printReceivablesHistory(input: PrintReceivablesHistoryReq, options?: RpcOptions): UnaryCall<PrintReceivablesHistoryReq, PrintReceivablesHistoryRes> {
        const method = this.methods[48], opt = this._transport.mergeOptions(options);
        return stackIntercept<PrintReceivablesHistoryReq, PrintReceivablesHistoryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchReceivablesAging
     */
    searchReceivablesAging(input: SearchReceivablesAgingReq, options?: RpcOptions): UnaryCall<SearchReceivablesAgingReq, SearchReceivablesAgingRes> {
        const method = this.methods[49], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchReceivablesAgingReq, SearchReceivablesAgingRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PrintReceivablesAging
     */
    printReceivablesAging(input: PrintReceivablesAgingReq, options?: RpcOptions): UnaryCall<PrintReceivablesAgingReq, PrintReceivablesAgingRes> {
        const method = this.methods[50], opt = this._transport.mergeOptions(options);
        return stackIntercept<PrintReceivablesAgingReq, PrintReceivablesAgingRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchReallocationReceivables
     */
    searchReallocationReceivables(input: SearchReallocationReceivablesReq, options?: RpcOptions): UnaryCall<SearchReallocationReceivablesReq, SearchReallocationReceivablesRes> {
        const method = this.methods[51], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchReallocationReceivablesReq, SearchReallocationReceivablesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: OmniSearch
     */
    omniSearch(input: OmniSearchReq, options?: RpcOptions): UnaryCall<OmniSearchReq, OmniSearchRes> {
        const method = this.methods[52], opt = this._transport.mergeOptions(options);
        return stackIntercept<OmniSearchReq, OmniSearchRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchChatThreads
     */
    searchChatThreads(input: SearchChatThreadsReq, options?: RpcOptions): UnaryCall<SearchChatThreadsReq, SearchChatThreadsRes> {
        const method = this.methods[53], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchChatThreadsReq, SearchChatThreadsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchChatMessages
     */
    searchChatMessages(input: SearchChatMessagesReq, options?: RpcOptions): UnaryCall<SearchChatMessagesReq, SearchChatMessagesRes> {
        const method = this.methods[54], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchChatMessagesReq, SearchChatMessagesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PollForNewChatMessages
     */
    pollForNewChatMessages(input: PollForNewChatMessagesReq, options?: RpcOptions): UnaryCall<PollForNewChatMessagesReq, PollForNewChatMessagesRes> {
        const method = this.methods[55], opt = this._transport.mergeOptions(options);
        return stackIntercept<PollForNewChatMessagesReq, PollForNewChatMessagesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PollForUnreadChatThreads
     */
    pollForUnreadChatThreads(input: PollForUnreadChatThreadsReq, options?: RpcOptions): UnaryCall<PollForUnreadChatThreadsReq, PollForUnreadChatThreadsRes> {
        const method = this.methods[56], opt = this._transport.mergeOptions(options);
        return stackIntercept<PollForUnreadChatThreadsReq, PollForUnreadChatThreadsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCatalogSKUs
     */
    searchCatalogSKUs(input: SearchCatalogSKUsReq, options?: RpcOptions): UnaryCall<SearchCatalogSKUsReq, SearchCatalogSKUsRes> {
        const method = this.methods[57], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCatalogSKUsReq, SearchCatalogSKUsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListIntegrationVendorsWithCatalogs
     */
    listIntegrationVendorsWithCatalogs(input: ListIntegrationVendorsWithCatalogsReq, options?: RpcOptions): UnaryCall<ListIntegrationVendorsWithCatalogsReq, ListIntegrationVendorsWithCatalogsRes> {
        const method = this.methods[58], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListIntegrationVendorsWithCatalogsReq, ListIntegrationVendorsWithCatalogsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCatalogProducts
     */
    searchCatalogProducts(input: SearchCatalogProductsReq, options?: RpcOptions): UnaryCall<SearchCatalogProductsReq, SearchCatalogProductsRes> {
        const method = this.methods[59], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCatalogProductsReq, SearchCatalogProductsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchGiftCards
     */
    searchGiftCards(input: SearchGiftCardsReq, options?: RpcOptions): UnaryCall<SearchGiftCardsReq, SearchGiftCardsRes> {
        const method = this.methods[60], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchGiftCardsReq, SearchGiftCardsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchSpiffs
     */
    searchSpiffs(input: SearchSpiffsReq, options?: RpcOptions): UnaryCall<SearchSpiffsReq, SearchSpiffsRes> {
        const method = this.methods[61], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchSpiffsReq, SearchSpiffsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchRoutines
     */
    searchRoutines(input: SearchRoutinesReq, options?: RpcOptions): UnaryCall<SearchRoutinesReq, SearchRoutinesRes> {
        const method = this.methods[62], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchRoutinesReq, SearchRoutinesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchConversations
     */
    searchConversations(input: SearchConversationsReq, options?: RpcOptions): UnaryCall<SearchConversationsReq, SearchConversationsRes> {
        const method = this.methods[63], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchConversationsReq, SearchConversationsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchListPromotionalSaleCodes
     */
    searchListPromotionalSaleCodes(input: SearchListPromotionalSaleCodesReq, options?: RpcOptions): UnaryCall<SearchListPromotionalSaleCodesReq, SearchListPromotionalSaleCodesRes> {
        const method = this.methods[64], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchListPromotionalSaleCodesReq, SearchListPromotionalSaleCodesRes>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service rd.search.service.BulkService
 */
export interface IBulkServiceClient {
    /**
     * @generated from protobuf rpc: BulkExportCustomers
     */
    bulkExportCustomers(input: BulkExportCustomersReq, options?: RpcOptions): UnaryCall<BulkExportCustomersReq, BulkExportCustomersRes>;
    /**
     * @generated from protobuf rpc: BulkExportJobs
     */
    bulkExportJobs(input: BulkExportJobsReq, options?: RpcOptions): UnaryCall<BulkExportJobsReq, BulkExportJobsRes>;
    /**
     * @generated from protobuf rpc: BulkExportCustomerContacts
     */
    bulkExportCustomerContacts(input: BulkExportCustomerContactsReq, options?: RpcOptions): UnaryCall<BulkExportCustomerContactsReq, BulkExportCustomerContactsRes>;
    /**
     * @generated from protobuf rpc: BulkExportProducts
     */
    bulkExportProducts(input: BulkExportProductsReq, options?: RpcOptions): UnaryCall<BulkExportProductsReq, BulkExportProductsRes>;
    /**
     * @generated from protobuf rpc: BulkExportProductLabels
     */
    bulkExportProductLabels(input: BulkExportProductLabelsReq, options?: RpcOptions): UnaryCall<BulkExportProductLabelsReq, BulkExportProductLabelsRes>;
    /**
     * @generated from protobuf rpc: BulkExportVendors
     */
    bulkExportVendors(input: BulkExportVendorsReq, options?: RpcOptions): UnaryCall<BulkExportVendorsReq, BulkExportVendorsRes>;
    /**
     * @generated from protobuf rpc: BulkExportUnitsOfMeasure
     */
    bulkExportUnitsOfMeasure(input: BulkExportUnitsOfMeasureReq, options?: RpcOptions): UnaryCall<BulkExportUnitsOfMeasureReq, BulkExportUnitsOfMeasureRes>;
    /**
     * @generated from protobuf rpc: BulkExportInventoryCountProducts
     */
    bulkExportInventoryCountProducts(input: BulkExportInventoryCountProductsReq, options?: RpcOptions): UnaryCall<BulkExportInventoryCountProductsReq, BulkExportInventoryCountProductsRes>;
    /**
     * @generated from protobuf rpc: BulkExportCustomPriceRules
     */
    bulkExportCustomPriceRules(input: BulkExportCustomPriceRulesReq, options?: RpcOptions): UnaryCall<BulkExportCustomPriceRulesReq, BulkExportCustomPriceRulesRes>;
    /**
     * @generated from protobuf rpc: BulkExportMappings
     */
    bulkExportMappings(input: BulkExportMappingsReq, options?: RpcOptions): UnaryCall<BulkExportMappingsReq, BulkExportMappingsRes>;
    /**
     * @generated from protobuf rpc: BulkExportAccounts
     */
    bulkExportAccounts(input: BulkExportAccountsReq, options?: RpcOptions): UnaryCall<BulkExportAccountsReq, BulkExportAccountsRes>;
    /**
     * @generated from protobuf rpc: BulkExportSpiffs
     */
    bulkExportSpiffs(input: BulkExportSpiffsReq, options?: RpcOptions): UnaryCall<BulkExportSpiffsReq, BulkExportSpiffsRes>;
    /**
     * @generated from protobuf rpc: BulkExportStaff
     */
    bulkExportStaff(input: BulkExportStaffReq, options?: RpcOptions): UnaryCall<BulkExportStaffReq, BulkExportStaffRes>;
    /**
     * @generated from protobuf rpc: BulkExportDepartments
     */
    bulkExportDepartments(input: BulkExportDepartmentsReq, options?: RpcOptions): UnaryCall<BulkExportDepartmentsReq, BulkExportDepartmentsRes>;
    /**
     * @generated from protobuf rpc: BulkExportClasses
     */
    bulkExportClasses(input: BulkExportClassesReq, options?: RpcOptions): UnaryCall<BulkExportClassesReq, BulkExportClassesRes>;
    /**
     * @generated from protobuf rpc: BulkExportFinelines
     */
    bulkExportFinelines(input: BulkExportFinelineReq, options?: RpcOptions): UnaryCall<BulkExportFinelineReq, BulkExportFinelineRes>;
    /**
     * @generated from protobuf rpc: BulkExportTags
     */
    bulkExportTags(input: BulkExportTagsReq, options?: RpcOptions): UnaryCall<BulkExportTagsReq, BulkExportTagsRes>;
}
/**
 * @generated from protobuf service rd.search.service.BulkService
 */
export class BulkServiceClient implements IBulkServiceClient, ServiceInfo {
    typeName = BulkService.typeName;
    methods = BulkService.methods;
    options = BulkService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: BulkExportCustomers
     */
    bulkExportCustomers(input: BulkExportCustomersReq, options?: RpcOptions): UnaryCall<BulkExportCustomersReq, BulkExportCustomersRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportCustomersReq, BulkExportCustomersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportJobs
     */
    bulkExportJobs(input: BulkExportJobsReq, options?: RpcOptions): UnaryCall<BulkExportJobsReq, BulkExportJobsRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportJobsReq, BulkExportJobsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportCustomerContacts
     */
    bulkExportCustomerContacts(input: BulkExportCustomerContactsReq, options?: RpcOptions): UnaryCall<BulkExportCustomerContactsReq, BulkExportCustomerContactsRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportCustomerContactsReq, BulkExportCustomerContactsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportProducts
     */
    bulkExportProducts(input: BulkExportProductsReq, options?: RpcOptions): UnaryCall<BulkExportProductsReq, BulkExportProductsRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportProductsReq, BulkExportProductsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportProductLabels
     */
    bulkExportProductLabels(input: BulkExportProductLabelsReq, options?: RpcOptions): UnaryCall<BulkExportProductLabelsReq, BulkExportProductLabelsRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportProductLabelsReq, BulkExportProductLabelsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportVendors
     */
    bulkExportVendors(input: BulkExportVendorsReq, options?: RpcOptions): UnaryCall<BulkExportVendorsReq, BulkExportVendorsRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportVendorsReq, BulkExportVendorsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportUnitsOfMeasure
     */
    bulkExportUnitsOfMeasure(input: BulkExportUnitsOfMeasureReq, options?: RpcOptions): UnaryCall<BulkExportUnitsOfMeasureReq, BulkExportUnitsOfMeasureRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportUnitsOfMeasureReq, BulkExportUnitsOfMeasureRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportInventoryCountProducts
     */
    bulkExportInventoryCountProducts(input: BulkExportInventoryCountProductsReq, options?: RpcOptions): UnaryCall<BulkExportInventoryCountProductsReq, BulkExportInventoryCountProductsRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportInventoryCountProductsReq, BulkExportInventoryCountProductsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportCustomPriceRules
     */
    bulkExportCustomPriceRules(input: BulkExportCustomPriceRulesReq, options?: RpcOptions): UnaryCall<BulkExportCustomPriceRulesReq, BulkExportCustomPriceRulesRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportCustomPriceRulesReq, BulkExportCustomPriceRulesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportMappings
     */
    bulkExportMappings(input: BulkExportMappingsReq, options?: RpcOptions): UnaryCall<BulkExportMappingsReq, BulkExportMappingsRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportMappingsReq, BulkExportMappingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportAccounts
     */
    bulkExportAccounts(input: BulkExportAccountsReq, options?: RpcOptions): UnaryCall<BulkExportAccountsReq, BulkExportAccountsRes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportAccountsReq, BulkExportAccountsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportSpiffs
     */
    bulkExportSpiffs(input: BulkExportSpiffsReq, options?: RpcOptions): UnaryCall<BulkExportSpiffsReq, BulkExportSpiffsRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportSpiffsReq, BulkExportSpiffsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportStaff
     */
    bulkExportStaff(input: BulkExportStaffReq, options?: RpcOptions): UnaryCall<BulkExportStaffReq, BulkExportStaffRes> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportStaffReq, BulkExportStaffRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportDepartments
     */
    bulkExportDepartments(input: BulkExportDepartmentsReq, options?: RpcOptions): UnaryCall<BulkExportDepartmentsReq, BulkExportDepartmentsRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportDepartmentsReq, BulkExportDepartmentsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportClasses
     */
    bulkExportClasses(input: BulkExportClassesReq, options?: RpcOptions): UnaryCall<BulkExportClassesReq, BulkExportClassesRes> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportClassesReq, BulkExportClassesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportFinelines
     */
    bulkExportFinelines(input: BulkExportFinelineReq, options?: RpcOptions): UnaryCall<BulkExportFinelineReq, BulkExportFinelineRes> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportFinelineReq, BulkExportFinelineRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkExportTags
     */
    bulkExportTags(input: BulkExportTagsReq, options?: RpcOptions): UnaryCall<BulkExportTagsReq, BulkExportTagsRes> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkExportTagsReq, BulkExportTagsRes>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service rd.search.service.SearchalyticsService
 */
export interface ISearchalyticsServiceClient {
    /**
     * Profit and Loss
     *
     * @generated from protobuf rpc: GetProfitAndLoss
     */
    getProfitAndLoss(input: GetProfitAndLossReq, options?: RpcOptions): UnaryCall<GetProfitAndLossReq, GetProfitAndLossRes>;
    /**
     * @generated from protobuf rpc: GetProfitAndLossPDF
     */
    getProfitAndLossPDF(input: GetProfitAndLossPDFReq, options?: RpcOptions): UnaryCall<GetProfitAndLossPDFReq, GetProfitAndLossPDFRes>;
    /**
     * Purchase Journal
     *
     * @generated from protobuf rpc: GetPurchaseJournal
     */
    getPurchaseJournal(input: GetPurchaseJournalReq, options?: RpcOptions): UnaryCall<GetPurchaseJournalReq, GetPurchaseJournalRes>;
    /**
     * @generated from protobuf rpc: GetPurchaseJournalPDF
     */
    getPurchaseJournalPDF(input: GetPurchaseJournalPDFReq, options?: RpcOptions): UnaryCall<GetPurchaseJournalPDFReq, GetPurchaseJournalPDFRes>;
    /**
     * @generated from protobuf rpc: GetPurchaseJournalCSV
     */
    getPurchaseJournalCSV(input: GetPurchaseJournalCSVReq, options?: RpcOptions): UnaryCall<GetPurchaseJournalCSVReq, GetPurchaseJournalCSVRes>;
    /**
     * Report Builder
     *
     * @generated from protobuf rpc: GetReportBuilder
     */
    getReportBuilder(input: GetReportBuilderReq, options?: RpcOptions): UnaryCall<GetReportBuilderReq, GetReportBuilderRes>;
    /**
     * @generated from protobuf rpc: GetReportBuilderEapi
     */
    getReportBuilderEapi(input: GetReportBuilderReq, options?: RpcOptions): UnaryCall<GetReportBuilderReq, GetReportBuilderEapiRes>;
    /**
     * @generated from protobuf rpc: GetReportBuilderConfig
     */
    getReportBuilderConfig(input: GetReportBuilderConfigReq, options?: RpcOptions): UnaryCall<GetReportBuilderConfigReq, GetReportBuilderConfigRes>;
    /**
     * @generated from protobuf rpc: RefreshSearchalyticsCache
     */
    refreshSearchalyticsCache(input: RefreshSearchalyticsCacheReq, options?: RpcOptions): UnaryCall<RefreshSearchalyticsCacheReq, RefreshSearchalyticsCacheRes>;
    /**
     * Payouts
     *
     * @generated from protobuf rpc: GetPayoutsByPayoutDate
     */
    getPayoutsByPayoutDate(input: GetPayoutsByPayoutDateReq, options?: RpcOptions): UnaryCall<GetPayoutsByPayoutDateReq, GetPayoutsByPayoutDateRes>;
    /**
     * @generated from protobuf rpc: GetPayoutsByPayoutDatePDF
     */
    getPayoutsByPayoutDatePDF(input: GetPayoutsByPayoutDatePDFReq, options?: RpcOptions): UnaryCall<GetPayoutsByPayoutDatePDFReq, GetPayoutsByPayoutDatePDFRes>;
    /**
     * @generated from protobuf rpc: GetPayoutsByPayoutDateCSV
     */
    getPayoutsByPayoutDateCSV(input: GetPayoutsByPayoutDateCSVReq, options?: RpcOptions): UnaryCall<GetPayoutsByPayoutDateCSVReq, GetPayoutsByPayoutDateCSVRes>;
    /**
     * @generated from protobuf rpc: GetPayoutsByTransactionDate
     */
    getPayoutsByTransactionDate(input: GetPayoutsByTransactionDateReq, options?: RpcOptions): UnaryCall<GetPayoutsByTransactionDateReq, GetPayoutsByTransactionDateRes>;
    /**
     * @generated from protobuf rpc: GetPayoutsByTransactionDatePDF
     */
    getPayoutsByTransactionDatePDF(input: GetPayoutsByTransactionDatePDFReq, options?: RpcOptions): UnaryCall<GetPayoutsByTransactionDatePDFReq, GetPayoutsByTransactionDatePDFRes>;
    /**
     * @generated from protobuf rpc: GetBalanceSheet
     */
    getBalanceSheet(input: GetBalanceSheetReq, options?: RpcOptions): UnaryCall<GetBalanceSheetReq, GetBalanceSheetRes>;
    /**
     * @generated from protobuf rpc: GetIncomeStatement
     */
    getIncomeStatement(input: GetIncomeStatementReq, options?: RpcOptions): UnaryCall<GetIncomeStatementReq, GetIncomeStatementRes>;
    /**
     * @generated from protobuf rpc: GetJournalEntries
     */
    getJournalEntries(input: GetJournalEntriesReq, options?: RpcOptions): UnaryCall<GetJournalEntriesReq, GetJournalEntriesRes>;
    /**
     * @generated from protobuf rpc: GetJournalEntriesPDF
     */
    getJournalEntriesPDF(input: GetJournalEntriesPDFReq, options?: RpcOptions): UnaryCall<GetJournalEntriesPDFReq, GetJournalEntriesPDFRes>;
    /**
     * @generated from protobuf rpc: GetJournalEntriesIIF
     */
    getJournalEntriesIIF(input: GetJournalEntriesIIFReq, options?: RpcOptions): UnaryCall<GetJournalEntriesIIFReq, GetJournalEntriesIIFRes>;
    /**
     * @generated from protobuf rpc: GetPayoutsByTransactionDateCSV
     */
    getPayoutsByTransactionDateCSV(input: GetPayoutsByTransactionDateCSVReq, options?: RpcOptions): UnaryCall<GetPayoutsByTransactionDateCSVReq, GetPayoutsByTransactionDateCSVRes>;
    /**
     * Accounting
     *
     * @generated from protobuf rpc: GetGeneralLedger
     */
    getGeneralLedger(input: GetGeneralLedgerReq, options?: RpcOptions): UnaryCall<GetGeneralLedgerReq, GetGeneralLedgerRes>;
    /**
     * @generated from protobuf rpc: GetGeneralLedgerPDF
     */
    getGeneralLedgerPDF(input: GetGeneralLedgerPDFReq, options?: RpcOptions): UnaryCall<GetGeneralLedgerPDFReq, GetGeneralLedgerPDFRes>;
    /**
     * @generated from protobuf rpc: GetGeneralLedgerCSV
     */
    getGeneralLedgerCSV(input: GetGeneralLedgerCSVReq, options?: RpcOptions): UnaryCall<GetGeneralLedgerCSVReq, GetGeneralLedgerCSVRes>;
}
/**
 * @generated from protobuf service rd.search.service.SearchalyticsService
 */
export class SearchalyticsServiceClient implements ISearchalyticsServiceClient, ServiceInfo {
    typeName = SearchalyticsService.typeName;
    methods = SearchalyticsService.methods;
    options = SearchalyticsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Profit and Loss
     *
     * @generated from protobuf rpc: GetProfitAndLoss
     */
    getProfitAndLoss(input: GetProfitAndLossReq, options?: RpcOptions): UnaryCall<GetProfitAndLossReq, GetProfitAndLossRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetProfitAndLossReq, GetProfitAndLossRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetProfitAndLossPDF
     */
    getProfitAndLossPDF(input: GetProfitAndLossPDFReq, options?: RpcOptions): UnaryCall<GetProfitAndLossPDFReq, GetProfitAndLossPDFRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetProfitAndLossPDFReq, GetProfitAndLossPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Purchase Journal
     *
     * @generated from protobuf rpc: GetPurchaseJournal
     */
    getPurchaseJournal(input: GetPurchaseJournalReq, options?: RpcOptions): UnaryCall<GetPurchaseJournalReq, GetPurchaseJournalRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPurchaseJournalReq, GetPurchaseJournalRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPurchaseJournalPDF
     */
    getPurchaseJournalPDF(input: GetPurchaseJournalPDFReq, options?: RpcOptions): UnaryCall<GetPurchaseJournalPDFReq, GetPurchaseJournalPDFRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPurchaseJournalPDFReq, GetPurchaseJournalPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPurchaseJournalCSV
     */
    getPurchaseJournalCSV(input: GetPurchaseJournalCSVReq, options?: RpcOptions): UnaryCall<GetPurchaseJournalCSVReq, GetPurchaseJournalCSVRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPurchaseJournalCSVReq, GetPurchaseJournalCSVRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Report Builder
     *
     * @generated from protobuf rpc: GetReportBuilder
     */
    getReportBuilder(input: GetReportBuilderReq, options?: RpcOptions): UnaryCall<GetReportBuilderReq, GetReportBuilderRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReportBuilderReq, GetReportBuilderRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetReportBuilderEapi
     */
    getReportBuilderEapi(input: GetReportBuilderReq, options?: RpcOptions): UnaryCall<GetReportBuilderReq, GetReportBuilderEapiRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReportBuilderReq, GetReportBuilderEapiRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetReportBuilderConfig
     */
    getReportBuilderConfig(input: GetReportBuilderConfigReq, options?: RpcOptions): UnaryCall<GetReportBuilderConfigReq, GetReportBuilderConfigRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReportBuilderConfigReq, GetReportBuilderConfigRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RefreshSearchalyticsCache
     */
    refreshSearchalyticsCache(input: RefreshSearchalyticsCacheReq, options?: RpcOptions): UnaryCall<RefreshSearchalyticsCacheReq, RefreshSearchalyticsCacheRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<RefreshSearchalyticsCacheReq, RefreshSearchalyticsCacheRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Payouts
     *
     * @generated from protobuf rpc: GetPayoutsByPayoutDate
     */
    getPayoutsByPayoutDate(input: GetPayoutsByPayoutDateReq, options?: RpcOptions): UnaryCall<GetPayoutsByPayoutDateReq, GetPayoutsByPayoutDateRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPayoutsByPayoutDateReq, GetPayoutsByPayoutDateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPayoutsByPayoutDatePDF
     */
    getPayoutsByPayoutDatePDF(input: GetPayoutsByPayoutDatePDFReq, options?: RpcOptions): UnaryCall<GetPayoutsByPayoutDatePDFReq, GetPayoutsByPayoutDatePDFRes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPayoutsByPayoutDatePDFReq, GetPayoutsByPayoutDatePDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPayoutsByPayoutDateCSV
     */
    getPayoutsByPayoutDateCSV(input: GetPayoutsByPayoutDateCSVReq, options?: RpcOptions): UnaryCall<GetPayoutsByPayoutDateCSVReq, GetPayoutsByPayoutDateCSVRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPayoutsByPayoutDateCSVReq, GetPayoutsByPayoutDateCSVRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPayoutsByTransactionDate
     */
    getPayoutsByTransactionDate(input: GetPayoutsByTransactionDateReq, options?: RpcOptions): UnaryCall<GetPayoutsByTransactionDateReq, GetPayoutsByTransactionDateRes> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPayoutsByTransactionDateReq, GetPayoutsByTransactionDateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPayoutsByTransactionDatePDF
     */
    getPayoutsByTransactionDatePDF(input: GetPayoutsByTransactionDatePDFReq, options?: RpcOptions): UnaryCall<GetPayoutsByTransactionDatePDFReq, GetPayoutsByTransactionDatePDFRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPayoutsByTransactionDatePDFReq, GetPayoutsByTransactionDatePDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBalanceSheet
     */
    getBalanceSheet(input: GetBalanceSheetReq, options?: RpcOptions): UnaryCall<GetBalanceSheetReq, GetBalanceSheetRes> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBalanceSheetReq, GetBalanceSheetRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIncomeStatement
     */
    getIncomeStatement(input: GetIncomeStatementReq, options?: RpcOptions): UnaryCall<GetIncomeStatementReq, GetIncomeStatementRes> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIncomeStatementReq, GetIncomeStatementRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetJournalEntries
     */
    getJournalEntries(input: GetJournalEntriesReq, options?: RpcOptions): UnaryCall<GetJournalEntriesReq, GetJournalEntriesRes> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetJournalEntriesReq, GetJournalEntriesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetJournalEntriesPDF
     */
    getJournalEntriesPDF(input: GetJournalEntriesPDFReq, options?: RpcOptions): UnaryCall<GetJournalEntriesPDFReq, GetJournalEntriesPDFRes> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetJournalEntriesPDFReq, GetJournalEntriesPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetJournalEntriesIIF
     */
    getJournalEntriesIIF(input: GetJournalEntriesIIFReq, options?: RpcOptions): UnaryCall<GetJournalEntriesIIFReq, GetJournalEntriesIIFRes> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetJournalEntriesIIFReq, GetJournalEntriesIIFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPayoutsByTransactionDateCSV
     */
    getPayoutsByTransactionDateCSV(input: GetPayoutsByTransactionDateCSVReq, options?: RpcOptions): UnaryCall<GetPayoutsByTransactionDateCSVReq, GetPayoutsByTransactionDateCSVRes> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPayoutsByTransactionDateCSVReq, GetPayoutsByTransactionDateCSVRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Accounting
     *
     * @generated from protobuf rpc: GetGeneralLedger
     */
    getGeneralLedger(input: GetGeneralLedgerReq, options?: RpcOptions): UnaryCall<GetGeneralLedgerReq, GetGeneralLedgerRes> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetGeneralLedgerReq, GetGeneralLedgerRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetGeneralLedgerPDF
     */
    getGeneralLedgerPDF(input: GetGeneralLedgerPDFReq, options?: RpcOptions): UnaryCall<GetGeneralLedgerPDFReq, GetGeneralLedgerPDFRes> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetGeneralLedgerPDFReq, GetGeneralLedgerPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetGeneralLedgerCSV
     */
    getGeneralLedgerCSV(input: GetGeneralLedgerCSVReq, options?: RpcOptions): UnaryCall<GetGeneralLedgerCSVReq, GetGeneralLedgerCSVRes> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetGeneralLedgerCSVReq, GetGeneralLedgerCSVRes>("unary", this._transport, method, opt, input);
    }
}
/**
 * CxaSearchService is for cxa specific search endpoints. The search service is
 * seperate because the system needs to be cleanly isolated from the pos.
 *
 * @generated from protobuf service rd.search.service.CxaSearchService
 */
export interface ICxaSearchServiceClient {
    /**
     * @generated from protobuf rpc: CxaSearchSales
     */
    cxaSearchSales(input: CxaSearchSalesReq, options?: RpcOptions): UnaryCall<CxaSearchSalesReq, CxaSearchSalesRes>;
    /**
     * @generated from protobuf rpc: CxaSearchOutstandingSales
     */
    cxaSearchOutstandingSales(input: CxaSearchOutstandingSalesReq, options?: RpcOptions): UnaryCall<CxaSearchOutstandingSalesReq, CxaSearchOutstandingSalesRes>;
    /**
     * @generated from protobuf rpc: CxaSearchReceivablesAging
     */
    cxaSearchReceivablesAging(input: CxaSearchReceivablesAgingReq, options?: RpcOptions): UnaryCall<CxaSearchReceivablesAgingReq, CxaSearchReceivablesAgingRes>;
    /**
     * @generated from protobuf rpc: CxaSearchReturns
     */
    cxaSearchReturns(input: CxaSearchReturnsReq, options?: RpcOptions): UnaryCall<CxaSearchReturnsReq, CxaSearchReturnsRes>;
    /**
     * @generated from protobuf rpc: CxaSearchJobs
     */
    cxaSearchJobs(input: CxaSearchJobsReq, options?: RpcOptions): UnaryCall<CxaSearchJobsReq, CxaSearchJobsRes>;
    /**
     * @generated from protobuf rpc: CxaSearchProducts
     */
    cxaSearchProducts(input: CxaSearchProductsReq, options?: RpcOptions): UnaryCall<CxaSearchProductsReq, CxaSearchProductsRes>;
    /**
     * @generated from protobuf rpc: CxaSearchTintColors
     */
    cxaSearchTintColors(input: CxaSearchTintColorsReq, options?: RpcOptions): UnaryCall<CxaSearchTintColorsReq, CxaSearchTintColorsRes>;
}
/**
 * CxaSearchService is for cxa specific search endpoints. The search service is
 * seperate because the system needs to be cleanly isolated from the pos.
 *
 * @generated from protobuf service rd.search.service.CxaSearchService
 */
export class CxaSearchServiceClient implements ICxaSearchServiceClient, ServiceInfo {
    typeName = CxaSearchService.typeName;
    methods = CxaSearchService.methods;
    options = CxaSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: CxaSearchSales
     */
    cxaSearchSales(input: CxaSearchSalesReq, options?: RpcOptions): UnaryCall<CxaSearchSalesReq, CxaSearchSalesRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CxaSearchSalesReq, CxaSearchSalesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CxaSearchOutstandingSales
     */
    cxaSearchOutstandingSales(input: CxaSearchOutstandingSalesReq, options?: RpcOptions): UnaryCall<CxaSearchOutstandingSalesReq, CxaSearchOutstandingSalesRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CxaSearchOutstandingSalesReq, CxaSearchOutstandingSalesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CxaSearchReceivablesAging
     */
    cxaSearchReceivablesAging(input: CxaSearchReceivablesAgingReq, options?: RpcOptions): UnaryCall<CxaSearchReceivablesAgingReq, CxaSearchReceivablesAgingRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<CxaSearchReceivablesAgingReq, CxaSearchReceivablesAgingRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CxaSearchReturns
     */
    cxaSearchReturns(input: CxaSearchReturnsReq, options?: RpcOptions): UnaryCall<CxaSearchReturnsReq, CxaSearchReturnsRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CxaSearchReturnsReq, CxaSearchReturnsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CxaSearchJobs
     */
    cxaSearchJobs(input: CxaSearchJobsReq, options?: RpcOptions): UnaryCall<CxaSearchJobsReq, CxaSearchJobsRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<CxaSearchJobsReq, CxaSearchJobsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CxaSearchProducts
     */
    cxaSearchProducts(input: CxaSearchProductsReq, options?: RpcOptions): UnaryCall<CxaSearchProductsReq, CxaSearchProductsRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<CxaSearchProductsReq, CxaSearchProductsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CxaSearchTintColors
     */
    cxaSearchTintColors(input: CxaSearchTintColorsReq, options?: RpcOptions): UnaryCall<CxaSearchTintColorsReq, CxaSearchTintColorsRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<CxaSearchTintColorsReq, CxaSearchTintColorsRes>("unary", this._transport, method, opt, input);
    }
}
